import get from 'lodash/get'

export const getAnswer = (state) => get(state, 'game.answer', '')



// WEBPACK FOOTER //
// ./src/containers/Game/containers/Translator/translatorSelectors.js